import React from "react";

const successStyle = "bg-[#E7F5E9] text-[#24AF22]";
const blueSuccessStyle = "bg-[#D6E4FF] text-[#1062D0]";
const historyStyle = "bg-[#FFF8DE] text-[#D07E10]";
const dangerStyle = "bg-[#FFEAF0] text-[#CB0B0B]";
const warningStyle = "bg-[#fbbf24] text-white";

const containerStyle: any = {
    "پرداخت شده": successStyle,
    "در انتظار استعلام": blueSuccessStyle,
    "ابطال شده": warningStyle,
    "رد شده": dangerStyle,
    "دریافت شده": successStyle,
    "پاس شده": successStyle,
    "وصول شده": successStyle,
    کامل: successStyle,
    "پایان یافته": successStyle,
    "تایید شده": blueSuccessStyle,
    " تایید شده": successStyle,
    "خرج شده": blueSuccessStyle,
    "پیش نویس": historyStyle,
    "درجریان وصول": historyStyle,
    ناقص: historyStyle,
    "مرجوع شده": dangerStyle,
    "عودت شده": dangerStyle,
    "سر رسید گذشته": dangerStyle,
    خرید: successStyle,
    فروش: dangerStyle,
};

export type Props = {
    title: string;
    value?: any;
};

function StatusComponent({ title, value }: Props) {
    let val = title;
    if (typeof value === "string") {
        val = value;
    }
    return (
        <div className="flex flex-row items-center justify-center">
            <div className={`py-1 px-2 rounded-full min-w-[80px] text-center ${containerStyle[val]}`}>{val}</div>
        </div>
    );
}

export default StatusComponent;
